import { validate } from "email-validator";

function cleanupEmail(email:string):string {
  // Remove leading and trailing spaces
  let cleanEmail = email?.trim().toLowerCase();

  // Remove invalid characters using a regular expression
  cleanEmail = cleanEmail.replace(/[^a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~.@]/g, "");
  return cleanEmail;
}

export function validateEmail(email:string):boolean {
  return validate(email);
}

export function cleanUpAndValidateEmail(email:string):string {
  if (typeof email !== "string") throw Error(`${email} email should be a string!`);
  const cleanEmail = cleanupEmail(email);
  if (!validate(cleanEmail)) throw Error(`email ${cleanEmail} is not a valid email address!`);
  return cleanEmail;
}
